









import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Magazine from '@/models/Magazine';
import MagazineImage from '@/models/MagazineImage';
import ScrollMixin from '@/misc/ScrollMixin';
import { mixins } from 'vue-class-component';

const MagazineStore = namespace('magazine');

@Component({})
export default class PageComponent extends mixins(ScrollMixin) {
    @MagazineStore.Getter('selectedMagazine')
    private selectedMagazine!: Magazine;

    @MagazineStore.Action('getMagazinePage')
    private getMagazinePage!: (payload: { publicationId: string, page: number }) => Promise<string>;

    @MagazineStore.Getter('getCachedImageByIdAndPage')
    private getCachedImageByIdAndPage!: (publicationId: string, page: number) => MagazineImage;

    @MagazineStore.Action('getMagazineThumbnail')
    private getMagazineThumbnail!: (payload: { publicationId: string, page: number }) => Promise<string>;

    @Prop({ default: 0 })
    public currentPage!: number;

    @Prop({ default: false })
    public isSplitPage!: boolean;

    public imageSource: string = '';
    public lazySource: string = '';

    /**
     * Check if the images should be centered or aligned to the left / right
     */
    get getPageImageAlignment() {
        if (this.currentPage === 0 || this.selectedMagazine.showSinglePage ||
            (this.currentPage === this.selectedMagazine.pageCount - 1 && this.currentPage % 2 !== 0)) {
            return 'center center';
        }

        if (this.$vuetify.breakpoint.mdAndUp && (this.isSplitPage && this.currentPage % 2 === 0)) {
            return 'left center';
        } else if (this.$vuetify.breakpoint.mdAndUp && (this.isSplitPage && this.currentPage % 2 !== 0)) {
            return 'right center';
        }
        return 'center center';
    }

    public async mounted() {
        const cachedImage = this.getCachedImageByIdAndPage(this.selectedMagazine.publicationId, this.currentPage);

        if (cachedImage) {
            this.imageSource = cachedImage.image.src;
        } else {

            this.lazySource = await this.getMagazineThumbnail({
                publicationId: this.selectedMagazine.publicationId,
                page: this.currentPage
            });

            this.imageSource = await this.getMagazinePage({
                publicationId: this.selectedMagazine.publicationId,
                page: this.currentPage
            });
        }
        this.checkCachedImages();
    }

    public checkCachedImages() {
        let cacheRange = 1; // Only cache the next and previous page
        if (this.isSplitPage) {
            cacheRange = 2; // Cache the next and previous two images for a better user experience
        }

        for (let cachePage = this.currentPage + 1;
             cachePage <= this.currentPage + cacheRange && cachePage <= this.selectedMagazine.pageCount;
             cachePage++) {
            this.checkImagePage(cachePage);
        }

        for (let cachePage = this.currentPage - cacheRange; cachePage <= this.currentPage - 1 && cachePage > 0; cachePage++) {
            this.checkImagePage(cachePage);
        }
    }

    public checkImagePage(page: number) {
        const checkImage = this.getCachedImageByIdAndPage(this.selectedMagazine.publicationId, page);
        if (!checkImage) {
            this.getMagazinePage({
                publicationId: this.selectedMagazine.publicationId,
                page: page
            });
        }
    }
};
